module.exports = __webpack_public_path__ + "img/dothemath.e2e0e355.png";